// import axios from '@/utils/axios';
import custApi from './custApi'
import WalletApi from './WalletApi'
import fileApi from './fileApi'
import OrderApi from './orderApi'
import MchApi from './MchApi'
import BaseApi from './BaseApi'
import nbiApi from './nbiApi'
import openApi from './openApi'
import systemApi from './systemApi'
import stlApi from './stl'
import taxApi from './taxApi'
import consignApi from './consignApi'
import payAgrApi from './payAgr'
export default {
  ...custApi,
  ...fileApi,
  ...WalletApi,
  ...OrderApi,
  ...MchApi,
  ...BaseApi,
  ...openApi,
  ...nbiApi,
  ...stlApi,
  ...taxApi,
  ...systemApi,
  ...consignApi,
  ...payAgrApi
  // 客户管理-个人客户-基础信息
  // custPage: (data) => axios.apiGet( baseURL + '/cust/person/page', data),
}
